module.exports = __webpack_public_path__ + "static/media/E9.2dfdc587.jpeg";